export interface GetCollectionForwardingRequestAssignRequest {
  id: number
  collectionNo: string
}

export function GetCollectionForwardingRequestAssignRequestToJSON(
  value: GetCollectionForwardingRequestAssignRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
